// extracted by mini-css-extract-plugin
export default {"overlayPosition":"overlayPosition_AI9xJ6D","overlayPositionComponent":"overlayPositionComponent_tggDToX"};